import { connect } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import * as actionCreator from '../../actions/';
import CacheMemory from '../../helpers/CacheMemory.js';
import AppOverlay from '../../components/Overlay/Overlay';

const CatchRedirection = ({
    appUserSession,
    setAppUserSession
}) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const entityIdTarget= searchParams.get('entityIdTarget');
    let sessionEncoded = searchParams.get('session');
    const [_, sessionData] = sessionEncoded.split(';');
    const expiresIn = Date.now() + (36000 * 1000);
    // need to set a new expires_in or deserialize will return null; 
    sessionEncoded = `${expiresIn};${sessionData}`;
    const session = CacheMemory.deserialize(sessionEncoded);
    session.expires_in = 36000;
    // check if entityIdTarget is a valid ObjectId string.
    const isEntityIdTargetValid = /^[0-9a-fA-F]{24}$/.test(entityIdTarget ? entityIdTarget : '');
    // check if decoded session has the minimum required.
    const isSessionValid = !!(
        session && 
        ['access_token', 'token', 'refresh_token', 'token_type'].every((item) => session.hasOwnProperty(item))
    );

    if (!isEntityIdTargetValid || !isSessionValid) {
        return <Navigate replace to="/"/>;
    }

    setAppUserSession({...session, currentVirtualAccount: entityIdTarget});
    // force reload or loginWall can't detect the new session set.
    return window.location.href = "/index.html";
    //return <Navigate replace to="/"/>;
}

const mapStateToProps = (appState) => ({
    appUserSession: appState.session,
});

const mapDispatchToProps = (dispatch) => ({
    setAppUserSession: (userSession) => dispatch(actionCreator.Session.setSession(userSession)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CatchRedirection);
